
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.2 1.6h-1.6v1.279a.32.32 0 0 1-.321.321h-.96a.32.32 0 0 1-.322-.321V.32a.316.316 0 0 0-.318-.32h-.96a.32.32 0 0 0-.322.321V1.6h-4.79v1.279a.32.32 0 0 1-.322.321h-.96a.32.32 0 0 1-.322-.321V1.6H4V.321A.319.319 0 0 0 3.679 0H2.72a.32.32 0 0 0-.32.321V1.6H.8c-.44 0-.8.36-.8.8v12.8c0 .44.36.8.8.8h14.4c.44 0 .8-.36.8-.8V2.4c0-.44-.36-.8-.8-.8zm-.8 12.479a.32.32 0 0 1-.321.321H1.92a.32.32 0 0 1-.321-.321V6.72a.32.32 0 0 1 .321-.321h12.16a.32.32 0 0 1 .321.321v7.358z"}}),_c('path',{attrs:{"d":"M5.279 8h-.96a.32.32 0 0 0-.322.321v.96a.32.32 0 0 0 .321.322h.96a.32.32 0 0 0 .322-.321v-.96A.32.32 0 0 0 5.279 8zm3.2 0h-.96a.32.32 0 0 0-.322.321v.96a.32.32 0 0 0 .321.322h.96a.32.32 0 0 0 .322-.321v-.96A.32.32 0 0 0 8.479 8zm3.2 0h-.96a.32.32 0 0 0-.322.321v.96a.32.32 0 0 0 .321.322h.96A.32.32 0 0 0 12 9.282v-.96A.32.32 0 0 0 11.679 8zm-6.4 3.2h-.96a.32.32 0 0 0-.322.321v.96a.32.32 0 0 0 .321.322h.96a.32.32 0 0 0 .322-.321v-.96a.319.319 0 0 0-.321-.322zm3.2 0h-.96a.32.32 0 0 0-.322.321v.96a.32.32 0 0 0 .321.322h.96a.32.32 0 0 0 .322-.321v-.96a.319.319 0 0 0-.321-.322zm3.2 0h-.96a.32.32 0 0 0-.322.321v.96a.32.32 0 0 0 .321.322h.96a.32.32 0 0 0 .322-.321v-.96a.319.319 0 0 0-.321-.322z"}})])
          )
        }
      }
    